export default __webpack_public_path__ + "static/1-35ed027652ada489b1dbabf452b0dfea.jpg";